// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {format, isValid} from 'date-fns'

import Vuex from 'vuex'
Vue.use(Vuex)

import App from './App'
import Store from './store/Store'
import router from './router'

//import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import VueFire from 'vuefire'
Vue.use(VueFire)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import VueHtml5Editor from 'vue-html5-editor'
Vue.use(VueHtml5Editor, {hiddenModules: ['info','hr','undo','font', 'align', 'unlink']})

import StringHelpers from './helpers/StringHelpers'
import ContactHelpers from './helpers/ContactHelpers'

import Croppa from 'vue-croppa'
Vue.use(Croppa)

import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

// See comments.vue
import VueTextareaAutosize from 'vue-textarea-autosize'
Vue.use(VueTextareaAutosize)

import NumberHelpers from './helpers/NumberHelpers'
import DataHelpers from './helpers/DataHelpers'

import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)



//CK editor...
import CKEditor from '@ckeditor/ckeditor5-vue'
Vue.use( CKEditor )

// //Froala editor...
// import 'froala-editor/css/froala_editor.pkgd.min.css'
// import VueFroala from 'vue-froala-wysiwyg'
// Vue.use(VueFroala)

Vue.use(require('vue-faker'), {locale: 'en_AU'})

//Global registrations for recursive components

import FormBlock from '@/forms/FormBlock'
Vue.component('FormBlock', FormBlock)

import ControlList from '@/forms/ControlList'
Vue.component('ControlList', ControlList)

import DynamicControl from '@/forms/DynamicControl'
Vue.component('DynamicControl', DynamicControl)

import InterfaceField from '@/builder/InterfaceField'
Vue.component('InterfaceField', InterfaceField)


import Flow from '@/flow/Flow'
Vue.component('Flow', Flow)


import ElementControl from '@/screens/ElementControl'
Vue.component('ElementControl', ElementControl)

import LayoutPanel from '@/ui-elements/LayoutPanel'
import DateHelpers from './helpers/DateHelpers'
Vue.component('LayoutPanel', LayoutPanel)


Vue.directive('showButKeepInner', {
    bind(el, bindings) {
        debugger
      bindings.def.wrap = function(el) {
        // Find all next siblings with data-moved and move back into el
        while (el.nextElementSibling && el.nextElementSibling.dataset.moved) {
          el.appendChild(el.nextElementSibling).removeAttribute('data-moved')
        }
        el.hidden = false
      }
  
      bindings.def.unwrap = function(el) {
        // Move all children of el outside and mark them with data-moved attr
        Array.from(el.children).forEach(child => {
          el.insertAdjacentElement('afterend', child).setAttribute('data-moved', true)
        })
        el.hidden = true
      }
    },
  
    inserted(el, bindings) {
        debugger
      bindings.def[bindings.value ? 'wrap' : 'unwrap'](el)
    },
  
    update(el, bindings) {
      bindings.def[bindings.value ? 'wrap' : 'unwrap'](el)
    }
})

Vue.filter('longDate', function(value){
    if(value)
        return format(DateHelpers.backwardsToDate(value), 'dd MMMM yy')
        //return moment(value).format("DD MMMM YY")
    else
        return ''
})

//This is intentionally written to take a yyyy-MM-dd date straight from the db.
Vue.filter('dueString', function(dateString){
    if(!dateString)
        return ''
    const date = DateHelpers.backwardsToDate(dateString)
    if(!isValid(date))
        return ''
    return StringHelpers.dueString(date)
})

Vue.filter('shortDate', function(dateString){
    if(!dateString)
        return ''
    const date = DateHelpers.toDate(dateString)
    return format(date, 'd/M')
})

Vue.filter('date', function(dateString){
    if(!dateString || dateString === true)
        return ''

    const date = DateHelpers.toDate(dateString)
 
    return format(date, 'dd/MM/yy')
})

Vue.filter('time', function(dateString){
    if(!dateString)
        return ''

    const date = DateHelpers.toDate(dateString)
 
    return format(date, 'dd/MM/yy hh:mma').toLowerCase()
})

Vue.filter('fromNow', function(date){
    return DateHelpers.fromNow(date)
})

Vue.filter('tag', function(str){
    return StringHelpers.restoreSpaces(str)
})

Vue.filter('timeAgo', function(date){
    return DateHelpers.timeAgo(date)
})

Vue.filter('fullName', function(contact){
    return ContactHelpers.fullName(contact)
})

Vue.filter('phoneNumbers', function(contact){
    return ContactHelpers.phoneNumbers(contact)
})

Vue.filter('phone', function(str){
    return StringHelpers.formatPhone(str)
})

Vue.filter('number', function(value){
    return StringHelpers.formatNumber(value)
})

Vue.filter('stamp', function(value){
    return DataHelpers.formatStamp(value)
})

Vue.filter('space', function(value){
    value = StringHelpers.camelToNormal(value)
    value = StringHelpers.snakeToNormal(value)
    return value

})

Vue.filter('thousands', function(value){
    return NumberHelpers.abbreviateNumber(value)
})

Vue.filter('currency', function(value){
    return StringHelpers.formatCurrency(value)
})

Vue.filter('cents', function(value){
    return StringHelpers.formatCurrencyWithCents(value)
})

Vue.config.productionTip = false

import Vuetify from 'vuetify'
Vue.use(Vuetify)

const vuetify = new Vuetify()

// Vuetify 2 method...
Vue.prototype.$eventBus = new Vue() // Global event bus

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  store: Store,
  vuetify: vuetify,
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js